import { css as h, unsafeCSS as Z, LitElement as f, html as n } from "lit";
import { state as P, customElement as g, property as l } from "lit/decorators.js";
import { classMap as _ } from "lit/directives/class-map.js";
import { repeat as $ } from "lit/directives/repeat.js";
import { createRef as mt, ref as ht } from "lit/directives/ref.js";
import { throttle as ft } from "lodash-es";
const gt = 160, ut = 160, bt = 1024, vt = [14743759, 8831084, 3172432, 464929], k = 4, L = 20, I = 22, V = 23, j = 24, N = 25, G = 26, H = 28, B = 30, Y = 31, K = 160, J = 1, Q = 2, tt = 16, et = 32, ot = 64, st = 128, rt = 1, at = 2, it = 4, nt = 1, lt = 2, S = 65536, dt = {
  PALETTE: {
    offset: k,
    len: 16
  },
  DRAW_COLORS: {
    offset: L,
    len: 2
  },
  GAMEPAD1: {
    offset: I,
    len: 1
  },
  GAMEPAD2: {
    offset: V,
    len: 1
  },
  GAMEPAD3: {
    offset: j,
    len: 1
  },
  GAMEPAD4: {
    offset: N,
    len: 1
  },
  MOUSE_X: {
    offset: G,
    len: 2
  },
  MOUSE_Y: {
    offset: H,
    len: 2
  },
  MOUSE_BUTTONS: {
    offset: B,
    len: 1
  },
  SYSTEM_FLAGS: {
    offset: Y,
    len: 1
  },
  RESERVED: {
    offset: 32,
    len: 128
  },
  FRAMEBUFFER: {
    offset: K,
    len: 6400
  },
  PROGRAM_MEMORY: {
    offset: 6560,
    len: 58976
  }
}, wt = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  ADDR_DRAW_COLORS: L,
  ADDR_FRAMEBUFFER: K,
  ADDR_GAMEPAD1: I,
  ADDR_GAMEPAD2: V,
  ADDR_GAMEPAD3: j,
  ADDR_GAMEPAD4: N,
  ADDR_MOUSE_BUTTONS: B,
  ADDR_MOUSE_X: G,
  ADDR_MOUSE_Y: H,
  ADDR_PALETTE: k,
  ADDR_SYSTEM_FLAGS: Y,
  BUTTON_DOWN: st,
  BUTTON_LEFT: tt,
  BUTTON_RIGHT: et,
  BUTTON_UP: ot,
  BUTTON_X: J,
  BUTTON_Z: Q,
  COLORS: vt,
  HEIGHT: ut,
  MAX_CART_SIZE: S,
  MOUSE_LEFT: rt,
  MOUSE_MIDDLE: it,
  MOUSE_RIGHT: at,
  STORAGE_SIZE: bt,
  SYSTEM_HIDE_GAMEPAD_OVERLAY: lt,
  SYSTEM_PRESERVE_FRAMEBUFFER: nt,
  WIDTH: gt,
  memoryMap: dt
}, Symbol.toStringTag, { value: "Module" }));
function xt(e) {
  const t = [0, 0, 0, 0];
  for (let o = 0; o < 4; o++)
    t[o] = e.getUint32(k + o * 4, !0);
  return t;
}
function yt(e, t) {
  return [
    e.getUint8(I) | t.gamepads[0],
    e.getUint8(V) | t.gamepads[1],
    e.getUint8(j) | t.gamepads[2],
    e.getUint8(N) | t.gamepads[3]
  ];
}
class _t {
  constructor(t, o) {
    const r = t.getInt16(G, !0), s = t.getInt16(H, !0);
    this.pointerPos = { x: r, y: s }, this.drawColors = t.getUint16(L, !0), this.palette = xt(t), this.gamepads = yt(t, o), this.systemFlags = t.getUint8(Y), this.mouseBtnByte = t.getUint8(B) | o.mouseButtons, this.getUint8 = (a) => t.getUint8(a), this.byteLen = t.byteLength;
  }
}
const z = "wasm4-update-completed";
function $t() {
  try {
    return window.localStorage.getItem("disk");
  } catch (e) {
    return console.error(e), null;
  }
}
function Et({ dataView: e, fps: t, bufferedData: o, wasmBufferByteLen: r }, s = { bubbles: !0 }) {
  return new CustomEvent(z, {
    ...s,
    detail: {
      memory: new _t(e, o),
      fps: t,
      wasmBufferByteLen: r,
      storedValue: $t()
    }
  });
}
class Dt {
  constructor(t) {
    this.state = null, this.handleUpdateEvt = ({ detail: o }) => {
      if (o != null && o.memory) {
        const r = {
          memoryView: o.memory,
          storedValue: o.storedValue ?? null,
          fps: o.fps,
          wasmBufferByteLen: o.wasmBufferByteLen
        };
        this.state = r, this.host.requestUpdate();
      }
    }, (this.host = t).addController(this);
  }
  hostConnected() {
    window.addEventListener(
      z,
      this.handleUpdateEvt
    );
  }
  hostDisconnected() {
    window.removeEventListener(
      z,
      this.handleUpdateEvt
    );
  }
}
const F = "wasm4-close-devtools-request";
function Ct() {
  return new CustomEvent(F, {
    bubbles: !0,
    composed: !0
  });
}
const Ot = h`:host{color:var(--wasm4-devtools-text-primary, #fff);background-color:var(--wasm4-devtools-bg-primary, #202020)}.text-primary{color:var(--wasm4-devtools-text-primary, #fff)!important}.text-secondary{color:var(--wasm4-devtools-text-secondary, rgba(255, 255, 255, .7))!important}.bg-primary{background-color:var(--wasm4-devtools-bg-primary, #202020)!important}.bg-secondary{background-color:var(--wasm4-devtools-bg-secondary, #444)!important}:host{font-size:var(--wasm4-devtools-text-size, 16px);font-family:monospace;text-rendering:optimizeLegibility;-webkit-font-smoothing:antialiased}.text-align-left{text-align:left!important}.text-align-right{text-align:right!important}.text-align-center{text-align:center!important}.active{color:var(--wasm4-devtools-text-primary, #fff)}.dim{opacity:.4}.display-block{display:block!important}.info-box{text-align:center;padding:.2em .4em;color:var(--wasm4-devtools-text-secondary, rgba(255, 255, 255, .7));background:var(--wasm4-devtools-bg-secondary, #444);border-radius:4px;min-width:60px;display:inline-block;font-size:.875em}.table{text-align:left;overflow:hidden;border-collapse:collapse;margin-bottom:0;border-style:solid;border-color:currentColor;border-width:1px;max-width:100%;font-size:var(--wasm4-devtools-text-size, 16px)}.table tbody,.table thead,.table tfoot,.table tr,.table td,.table th{overflow-wrap:break-word;text-align:inherit;font-size:inherit}.table td,.table th{border-width:0;border-style:none;border-color:inherit;font-size:.875em;padding:.3em .4em;min-width:50px;border-bottom:1px solid currentColor}a,a:visited{color:var(--wasm4-devtools-text-primary, #fff);outline:none;font-size:.875em}a:focus{color:var(--wasm4-devtools-text-secondary, rgba(255, 255, 255, .7))}.list{padding-left:1.2em}.list li{list-style:disc}.fixed-wrapper{position:fixed;background:transparent;top:0;right:0;padding:4px;height:100vh;z-index:var(--wasm4-devtools-window-z-index, 11);pointer-events:none}.fixed-wrapper.pos-right .toggle-pos-btn{transform:rotateY(-180deg)}.fixed-wrapper.pos-left{right:auto;left:0}.fixed-wrapper.pos-left .toggle-pos-btn{transform:rotateY(0)}.devtools-wrapper{display:block;border:solid 1px gray;border-radius:4px;overflow:hidden;width:320px;position:relative;max-height:100%;pointer-events:auto}.devtools-wrapper:before{content:"";height:2.923em;width:100%}.devtools-wrapper .devtools-top-static-placeholder{height:2.923em;width:100%;padding:0}.devtools-wrapper .devtools-top{display:grid;grid-template-columns:1r auto;justify-content:space-between;grid-template-areas:". win-btn";align-items:center;overflow:hidden;padding:0 8px;position:absolute;background:theme;z-index:5;left:0;top:0;width:100%;height:2.923em}.devtools-wrapper .devtools-top-btn{grid-area:win-btn;height:inherit;-webkit-user-select:none;user-select:none;display:flex;justify-content:flex-end;align-items:center;grid-gap:4px}.devtools-wrapper .top-btn{border-radius:4px;background:transparent;border:none;box-shadow:none;color:inherit;display:flex;justify-content:center;align-items:center;width:2.2em;height:2.2em;cursor:pointer}.devtools-wrapper .devtools-body{max-height:calc(100vh - 2.923em - 8px);padding:0 8px 8px;overflow-x:hidden;overflow-y:auto}.devtools-wrapper .devtools-body::-webkit-scrollbar{-webkit-appearance:none;width:7px}.devtools-wrapper .devtools-body::-webkit-scrollbar-thumb{border-radius:4px;background-color:var(--wasm4-devtools-text-secondary, rgba(255, 255, 255, .7));box-shadow:0 0 1px #ffffff80}.mouse-pos-list{display:grid;grid-template-columns:repeat(2,50px);grid-gap:16px}.mouse-pos{white-space:nowrap}.inline-section{display:flex;flex-flow:row nowrap;grid-gap:16px;align-items:center}.inline-section>*{margin:0}.cart-size-wrapper{display:grid;grid-auto-flow:row;justify-content:flex-start;align-items:flex-start;grid-gap:.25em}.cart-size-wrapper .size-box{display:flex;justify-content:space-between}.flags-wrapper{display:grid;grid-template-rows:1fr 1fr;grid-gap:16px}.flags-wrapper .flag-label{font-size:.875em}.tabs{display:flex;flex-flow:row nowrap;grid-gap:4px;cursor:pointer;font-weight:900;-webkit-user-select:none;user-select:none}.tabs .tab-item{pointer-events:auto;padding:4px}.tabs .tab-item[data-active="1"]{border-bottom:1px solid currentColor}`, Pt = h`*,*:before,*:after{box-sizing:border-box}section{padding:.4em 0}article{padding:.4em 0}ul{list-style:none;margin:0;padding:.2em 0}h1,h2,h3,h4,h5,h6{margin:.4em 0;font-size:1em}p{padding:0;margin:0}[hidden]{display:none!important}`, Bt = h`:host{color:var(--wasm4-devtools-text-primary, #fff);background-color:var(--wasm4-devtools-bg-primary, #202020)}.text-primary{color:var(--wasm4-devtools-text-primary, #fff)!important}.text-secondary{color:var(--wasm4-devtools-text-secondary, rgba(255, 255, 255, .7))!important}.bg-primary{background-color:var(--wasm4-devtools-bg-primary, #202020)!important}.bg-secondary{background-color:var(--wasm4-devtools-bg-secondary, #444)!important}:host{font-size:var(--wasm4-devtools-text-size, 16px);font-family:monospace;text-rendering:optimizeLegibility;-webkit-font-smoothing:antialiased}.text-align-left{text-align:left!important}.text-align-right{text-align:right!important}.text-align-center{text-align:center!important}.active{color:var(--wasm4-devtools-text-primary, #fff)}.dim{opacity:.4}.display-block{display:block!important}.info-box{text-align:center;padding:.2em .4em;color:var(--wasm4-devtools-text-secondary, rgba(255, 255, 255, .7));background:var(--wasm4-devtools-bg-secondary, #444);border-radius:4px;min-width:60px;display:inline-block;font-size:.875em}.table{text-align:left;overflow:hidden;border-collapse:collapse;margin-bottom:0;border-style:solid;border-color:currentColor;border-width:1px;max-width:100%;font-size:var(--wasm4-devtools-text-size, 16px)}.table tbody,.table thead,.table tfoot,.table tr,.table td,.table th{overflow-wrap:break-word;text-align:inherit;font-size:inherit}.table td,.table th{border-width:0;border-style:none;border-color:inherit;font-size:.875em;padding:.3em .4em;min-width:50px;border-bottom:1px solid currentColor}a,a:visited{color:var(--wasm4-devtools-text-primary, #fff);outline:none;font-size:.875em}a:focus{color:var(--wasm4-devtools-text-secondary, rgba(255, 255, 255, .7))}.list{padding-left:1.2em}.list li{list-style:disc}`, Rt = [Pt, Bt].map((e) => Z(e));
function u(...e) {
  return Rt.concat(
    e.map(
      (t) => typeof t == "string" ? Z(t) : t
    )
  );
}
function Tt(e) {
  return `#${e.toString(16).toLowerCase().padStart(6, "0")}`;
}
function E(e, t = 2) {
  return e.toString(16).padStart(t, "0").toUpperCase();
}
function W(e) {
  return e;
}
function C(e, t = 0) {
  return (1 << e) - 1 ^ (1 << t) - 1;
}
function At(e, t) {
  const o = Math.max(0, Math.min(t, e.byteLen - 1));
  let r = [];
  for (let s = o, a = o + 16; s < a; s++)
    r[s] = E(e.getUint8(s), 2);
  return r.join(" ");
}
function X(e, t, o = 1) {
  if (!Number.isFinite(e) || !Number.isFinite(t) || !Number.isFinite(o) || e > t || o === 0)
    throw new TypeError(
      `invalid range input: from ${e}, to ${t}, step ${o}`
    );
  const r = (t - e) / o >> 0;
  let s = [];
  for (let a = 0; a < r; a++)
    s[a] = o * a + e;
  return s;
}
var Mt = Object.defineProperty, St = Object.getOwnPropertyDescriptor, R = (e, t, o, r) => {
  for (var s = r > 1 ? void 0 : r ? St(t, o) : t, a = e.length - 1, i; a >= 0; a--)
    (i = e[a]) && (s = (r ? i(t, o, s) : i(s)) || s);
  return r && s && Mt(t, o, s), s;
};
const U = "wasm4-devtools", A = ["general", "controls", "mem", "info"], zt = [C(3), C(7, 3), C(11, 7), C(15, 11)];
let v = class extends f {
  constructor() {
    super(...arguments), this.updateController = new Dt(this), this._expanded = !0, this._activeTab = A[0], this._fixedPosition = "right", this._handleCloseButtonClick = () => {
      this.dispatchEvent(Ct());
    }, this._handleTabClick = (e) => {
      var o;
      const t = (o = e.composedPath()[0]) == null ? void 0 : o.dataset.tabValue;
      A.includes(t) && (this._activeTab = t);
    }, this._toggleExapanded = () => {
      this._expanded = !this._expanded;
    }, this._changeFixedPosition = () => {
      this._fixedPosition = this._fixedPosition === "left" ? "right" : "left";
    }, this._renderGeneralView = ({
      memoryView: e,
      fps: t,
      wasmBufferByteLen: o
    }) => {
      const r = e.drawColors ?? 0;
      return n`<article>
      <wasm4-palette
        palette-heading="palette"
        .palette=${e.palette}
      ></wasm4-palette>
      <section>
        <h4>draw colors</h4>
        <table class="table text-align-right">
          <thead>
            <tr>
              <th>color</th>
              <th>value</th>
            </tr>
          </thead>
          <tbody>
            ${$(
        zt,
        W,
        (s, a) => n`<tr>
                <td class="text-align-center">${a + 1}</td>
                <td>${r & s}</td>
              </tr>`
      )}
          </tbody>
          <tfoot>
            <tr>
              <td class="text-align-center">sum</td>
              <td>${r}</td>
            </tr>
          </tfoot>
        </table>
      </section>
      <section class="inline-section">
        <h4>fps</h4>
        <span class="info-box text-primary">${t}</span>
      </section>
      <section class="cart-size-wrapper">
        <h4>cartridge size ${o > S ? "⚠️" : ""}</h4>
        <div class="size-box">
          current
          <span class="info-box text-primary">${o}B</span>
        </div>
        <div class="size-box">
          limit <span class="info-box text-primary">${S}B</span>
        </div>
      </section>
      <section class="flags-section">
        <h4>system flags</h4>
        <div class="flags-wrapper">
          <div>
            <span class="flag-label">preserve framebuffer</span>
            <span class="info-box text-primary"
              >${e.systemFlags & nt}</span
            >
          </div>
          <div>
            <span class="flag-label">hide gamepad overlay</span>
            <span class="info-box text-primary"
              >${e.systemFlags & lt}</span
            >
          </div>
        </div>
      </section>
    </article>`;
    }, this._renderInfo = () => n` <wasm4-info-view></wasm4-info-view> `, this._renderControls = ({ memoryView: e }) => n`<wasm4-controls-view
      .mouseButtons=${e.mouseBtnByte}
      .mouseX=${e.pointerPos.x}
      .mouseY=${e.pointerPos.y}
      .gamepads=${e.gamepads}
    ></wasm4-controls-view>`, this._renderMemory = ({ memoryView: e }) => n`<wasm4-memory-view
      .memoryView=${e}
    ></wasm4-memory-view>`, this._renderTab = (e) => {
      let t;
      switch (this._activeTab) {
        case "controls":
          t = this._renderControls;
          break;
        case "info":
          t = this._renderInfo;
          break;
        case "mem":
          t = this._renderMemory;
          break;
        default:
          t = this._renderGeneralView;
      }
      return t.call(this, e);
    };
  }
  render() {
    if (!this.updateController.state)
      return null;
    const e = `move ${this._fixedPosition === "left" ? "right" : "left"}`;
    return n`<div
      class=${_({
      "fixed-wrapper": 1,
      [`pos-${this._fixedPosition}`]: 1
    })}
    >
      <div class="devtools-wrapper bg-primary">
        <div class="devtools-top-static-placeholder"></div>
        <div class="devtools-top bg-primary">
          <h2>devtools</h2>
          <div class="devtools-top-btn">
            <button
              type="button"
              aria-label="collapse"
              class="top-btn"
              title="collapse"
              @click=${this._toggleExapanded}
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 24 24"
                height="24px"
                width="24px"
                fill="currentColor"
              >
                <path d="M0 0h24v24H0V0z" fill="none" />
                <path d="M6 19h12v2H6v-2z" />
              </svg>
            </button>
            <button
              type="button"
              aria-label=${e}
              class="top-btn toggle-pos-btn"
              title=${e}
              @click=${this._changeFixedPosition}
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 24 24"
                height="24px"
                width="24px"
                fill="currentColor"
              >
                <path d="M0 0h24v24H0V0z" fill="none" />
                <path d="M10 6L8.59 7.41 13.17 12l-4.58 4.59L10 18l6-6z" />
              </svg>
            </button>
            <button
              type="button"
              aria-label="close"
              class="top-btn"
              title="close"
              @click=${this._handleCloseButtonClick}
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 24 24"
                height="24px"
                width="24px"
                fill="currentColor"
              >
                <path d="M0 0h24v24H0V0z" fill="none" />
                <path
                  d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12 19 6.41z"
                />
              </svg>
            </button>
          </div>
        </div>
        <div class="devtools-body" ?hidden=${!this._expanded}>
          <ul class="tabs" @click=${this._handleTabClick}>
            ${$(
      A,
      W,
      (t) => n`<li
                  data-tab-value=${t}
                  data-active=${+(t === this._activeTab)}
                  class="tab-item"
                >
                  ${t}
                </li>`
    )}
          </ul>
          ${this._renderTab(this.updateController.state)}
        </div>
      </div>
    </div>`;
  }
};
v.styles = u(Ot);
R([
  P()
], v.prototype, "_expanded", 2);
R([
  P()
], v.prototype, "_activeTab", 2);
R([
  P()
], v.prototype, "_fixedPosition", 2);
v = R([
  g(U)
], v);
const Ft = h`.palette-grid{display:grid;grid-template-columns:repeat(4,1fr);height:50px;border-radius:4px;overflow:hidden;font-weight:800;font-size:.875em}.palette-grid .color-box{display:flex;align-items:center;justify-content:center}.palette-article h3{margin-bottom:.2em}`;
var Ut = Object.defineProperty, kt = Object.getOwnPropertyDescriptor, q = (e, t, o, r) => {
  for (var s = r > 1 ? void 0 : r ? kt(t, o) : t, a = e.length - 1, i; a >= 0; a--)
    (i = e[a]) && (s = (r ? i(t, o, s) : i(s)) || s);
  return r && s && Ut(t, o, s), s;
};
const Lt = "wasm4-palette";
let D = class extends f {
  constructor() {
    super(...arguments), this.palette = [0, 0, 0, 0], this.heading = "";
  }
  render() {
    return n`<section class="palette-article">
      ${this.heading && n`<h4>${this.heading}</h4>`}
      <div class="palette-grid">
        ${this.palette.slice(0, 4).map((e) => {
      const t = Tt(e), r = ((e & 255) + (e >> 8 & 255) + (e >> 16)) / 3 > 128 ? "filter: invert(1)" : "";
      return n`<div
            class="color-box"
            data-color="${t}"
            style="background: ${t}"
          >
            <div style=${r}>${t}</div>
          </div>`;
    })}
      </div>
    </section>`;
  }
};
D.styles = u(Ft);
q([
  l({ type: Array })
], D.prototype, "palette", 2);
q([
  l({ type: String, attribute: "palette-heading" })
], D.prototype, "heading", 2);
D = q([
  g(Lt)
], D);
const It = h`.gamepad{pointer-events:none;position:relative;display:grid;grid-template-columns:1fr 1fr;justify-content:space-between;overflow:hidden}.gamepad-dpad{position:relative;width:39px;height:120px;background:#444;border-radius:9px;left:40px}.gamepad-dpad:before{position:absolute;width:120px;height:39px;top:39px;left:-39px;background:#444;border-radius:9px;content:""}.gamepad-dpad:after{position:absolute;height:39px;width:39px;top:39px;border-radius:100%;background:#333;content:""}.gamepad-dpad.pressed-left:before{border-left:4px solid #a93671;width:116px}.gamepad-dpad.pressed-right:before{border-right:4px solid #a93671;width:116px}.gamepad-dpad.pressed-up{border-top:4px solid #a93671}.gamepad-dpad.pressed-down{border-bottom:4px solid #a93671;height:116px}.gamepad-action1,.gamepad-action2{width:60px;height:60px;border:4px solid #a93671;border-radius:50px;flex:0 0 auto}.gamepad-action1{position:relative;right:60px}.gamepad-action1.pressed,.gamepad-action2.pressed{background:#a93671}.gamepad-actions{display:flex;flex-flow:column-reverse nowrap;align-items:flex-end;position:relative}`;
var Vt = Object.defineProperty, jt = Object.getOwnPropertyDescriptor, m = (e, t, o, r) => {
  for (var s = r > 1 ? void 0 : r ? jt(t, o) : t, a = e.length - 1, i; a >= 0; a--)
    (i = e[a]) && (s = (r ? i(t, o, s) : i(s)) || s);
  return r && s && Vt(t, o, s), s;
};
const Nt = "wasm4-gamepad";
let d = class extends f {
  constructor() {
    super(...arguments), this.action1 = !1, this.action2 = !1, this.up = !1, this.down = !1, this.left = !1, this.right = !1, this.rawValue = 0;
  }
  render() {
    const e = this.up || !!(this.rawValue & ot), t = this.down || !!(this.rawValue & st), o = this.left || !!(this.rawValue & tt), r = this.right || !!(this.rawValue & et), s = this.action1 || !!(this.rawValue & J), a = this.action2 || !!(this.rawValue & Q);
    return n`<div class="gamepad">
      <div
        class="${_({
      "gamepad-dpad": 1,
      "pressed-right": r,
      "pressed-down": t,
      "pressed-left": o,
      "pressed-up": e
    })}"
      ></div>
      <div class="gamepad-actions">
        <div
          class="${_({ "gamepad-action1": 1, pressed: s })}"
        ></div>
        <div
          class="${_({ "gamepad-action2": 1, pressed: a })}"
        ></div>
      </div>
    </div>`;
  }
};
d.styles = u(It);
m([
  l({ type: Boolean, reflect: !0, attribute: "action-1" })
], d.prototype, "action1", 2);
m([
  l({ type: Boolean, reflect: !0, attribute: "action-2" })
], d.prototype, "action2", 2);
m([
  l({ type: Boolean, reflect: !0 })
], d.prototype, "up", 2);
m([
  l({ type: Boolean, reflect: !0 })
], d.prototype, "down", 2);
m([
  l({ type: Boolean, reflect: !0 })
], d.prototype, "left", 2);
m([
  l({ type: Boolean, reflect: !0 })
], d.prototype, "right", 2);
m([
  l({ type: Number, reflect: !0, attribute: "raw-value" })
], d.prototype, "rawValue", 2);
d = m([
  g(Nt)
], d);
var Gt = Object.defineProperty, Ht = Object.getOwnPropertyDescriptor, x = (e, t, o, r) => {
  for (var s = r > 1 ? void 0 : r ? Ht(t, o) : t, a = e.length - 1, i; a >= 0; a--)
    (i = e[a]) && (s = (r ? i(t, o, s) : i(s)) || s);
  return r && s && Gt(t, o, s), s;
};
const Yt = "wasm4-controls-view";
let p = class extends f {
  constructor() {
    super(...arguments), this.mouseButtons = 0, this.gamepads = [0, 0, 0, 0], this.mouseX = 0, this.mouseY = 0, this.heading = "";
  }
  render() {
    return n`<article class="bg-primary" part="root-view">
      ${this.heading && n`<h3 class="heading">${this.heading}</h3>`}
      <section class="mouse-section">
        <h4 class="heading">mouse position</h4>
        <ul class="mouse-pos-list">
          <li class="info-box mouse-pos">
            <span class="text-primary">x: ${this.mouseX}</span>
          </li>
          <li class="info-box mouse-pos">
            <span class="text-primary">y: ${this.mouseY}</span>
          </li>
        </ul>
      </section>
      <wasm4-mouse-buttons
        heading="mouse buttons"
        raw-value=${this.mouseButtons}
      ></wasm4-mouse-buttons>
      ${this.gamepads.map(
      (e, t) => n`<section>
            <h4>gamepad ${t + 1}</h4>
            <wasm4-gamepad raw-value=${e}></wasm4-gamepad>
          </section>`
    )}
    </article>`;
  }
};
p.styles = u();
x([
  l({ type: Number })
], p.prototype, "mouseButtons", 2);
x([
  l({ type: Array })
], p.prototype, "gamepads", 2);
x([
  l({ type: Number })
], p.prototype, "mouseX", 2);
x([
  l({ type: Number })
], p.prototype, "mouseY", 2);
x([
  l({ type: String, reflect: !0 })
], p.prototype, "heading", 2);
p = x([
  g(Yt)
], p);
const qt = h`.mouse-buttons{display:grid;grid-template-columns:repeat(3,1fr);grid-gap:8px}`;
var Wt = Object.defineProperty, Xt = Object.getOwnPropertyDescriptor, y = (e, t, o, r) => {
  for (var s = r > 1 ? void 0 : r ? Xt(t, o) : t, a = e.length - 1, i; a >= 0; a--)
    (i = e[a]) && (s = (r ? i(t, o, s) : i(s)) || s);
  return r && s && Wt(t, o, s), s;
};
const Zt = "wasm4-mouse-buttons";
let c = class extends f {
  constructor() {
    super(...arguments), this.middle = !1, this.right = !1, this.left = !1, this.rawValue = 0, this.heading = "";
  }
  render() {
    const e = {
      left: this.left || !!(this.rawValue & rt),
      middle: this.middle || !!(this.rawValue & it),
      right: this.right || !!(this.rawValue & at)
    };
    return n`<section>
      ${this.heading && n`<h4 class="heading">${this.heading}</h4>`}
      <ul class="mouse-buttons">
        ${Object.entries(e).map(
      ([t, o]) => n`<li
              class=${_({
        "info-box": 1,
        dim: !o,
        "text-primary": o
      })}
            >
              ${t}
            </li>`
    )}
      </ul>
    </section> `;
  }
};
c.styles = u(qt);
y([
  l({ type: Boolean, reflect: !0 })
], c.prototype, "middle", 2);
y([
  l({ type: Boolean, reflect: !0 })
], c.prototype, "right", 2);
y([
  l({ type: Boolean, reflect: !0 })
], c.prototype, "left", 2);
y([
  l({ type: Number, reflect: !0, attribute: "raw-value" })
], c.prototype, "rawValue", 2);
y([
  l({ type: String, reflect: !0 })
], c.prototype, "heading", 2);
c = y([
  g(Zt)
], c);
const Kt = h`:host{color:var(--wasm4-devtools-text-primary, #fff);background-color:var(--wasm4-devtools-bg-primary, #202020)}.text-primary{color:var(--wasm4-devtools-text-primary, #fff)!important}.text-secondary{color:var(--wasm4-devtools-text-secondary, rgba(255, 255, 255, .7))!important}.bg-primary{background-color:var(--wasm4-devtools-bg-primary, #202020)!important}.bg-secondary{background-color:var(--wasm4-devtools-bg-secondary, #444)!important}:host{font-size:var(--wasm4-devtools-text-size, 16px);font-family:monospace;text-rendering:optimizeLegibility;-webkit-font-smoothing:antialiased}.text-align-left{text-align:left!important}.text-align-right{text-align:right!important}.text-align-center{text-align:center!important}.active{color:var(--wasm4-devtools-text-primary, #fff)}.dim{opacity:.4}.display-block{display:block!important}.info-box{text-align:center;padding:.2em .4em;color:var(--wasm4-devtools-text-secondary, rgba(255, 255, 255, .7));background:var(--wasm4-devtools-bg-secondary, #444);border-radius:4px;min-width:60px;display:inline-block;font-size:.875em}.table{text-align:left;overflow:hidden;border-collapse:collapse;margin-bottom:0;border-style:solid;border-color:currentColor;border-width:1px;max-width:100%;font-size:var(--wasm4-devtools-text-size, 16px)}.table tbody,.table thead,.table tfoot,.table tr,.table td,.table th{overflow-wrap:break-word;text-align:inherit;font-size:inherit}.table td,.table th{border-width:0;border-style:none;border-color:inherit;font-size:.875em;padding:.3em .4em;min-width:50px;border-bottom:1px solid currentColor}a,a:visited{color:var(--wasm4-devtools-text-primary, #fff);outline:none;font-size:.875em}a:focus{color:var(--wasm4-devtools-text-secondary, rgba(255, 255, 255, .7))}.list{padding-left:1.2em}.list li{list-style:disc}.memory-map{image-rendering:pixelated;border:2px solid gray;border-radius:4px;flex:0 0 auto;align-self:center}.color-formula{font-size:.65em;padding:.1em;max-width:280px}.memory-map-wrapper{display:block;margin:0 auto}.hex-view{padding:.2em 0;min-height:80px;font-size:.61em;width:max-content;white-space:nowrap;overflow-x:hidden;text-transform:uppercase}.hex-view .hex-header{border-bottom:1px solid var(--wasm4-devtools-text-primary, #fff);margin-bottom:.5em;padding:.5em 0}.hex-form{font-size:.875em}.hex-form input[type=number]{width:75px;border:none;margin:0;padding:.2em;line-height:1.15;border-radius:4px}.hex-form .form-group{display:flex;justify-content:flex-start;align-items:center;grid-gap:4px}`;
var Jt = Object.defineProperty, Qt = Object.getOwnPropertyDescriptor, T = (e, t, o, r) => {
  for (var s = r > 1 ? void 0 : r ? Qt(t, o) : t, a = e.length - 1, i; a >= 0; a--)
    (i = e[a]) && (s = (r ? i(t, o, s) : i(s)) || s);
  return r && s && Jt(t, o, s), s;
};
const te = "wasm4-memory-view", b = 256, M = 65520, ee = "b = (byte & 0xf) << 4; g = (byte & 0xf0)";
let w = class extends f {
  constructor() {
    super(...arguments), this.heading = "", this.memoryView = null, this.hexEditor = {
      values: {
        firstRow: 0
      }
    }, this._hexViewFirstRow = X(0, 16).map((e) => E(e)).join(" "), this.memoryCanvasRef = mt(), this.imageData = new ImageData(b, b), this._animationFrameRequestId = 0, this._paintMemoryCanvas = () => {
      var o;
      const e = (o = this.memoryCanvasRef.value) == null ? void 0 : o.getContext("2d"), t = this.memoryView;
      if (!(!t || !e)) {
        e.clearRect(0, 0, b, b);
        for (let r = 0, s = this.imageData.data.byteLength; r < s; r += 4) {
          const a = t.getUint8(r / 4), i = a & 240, ct = (a & 15) << 4;
          this.imageData.data[r] = 0, this.imageData.data[r + 1] = i, this.imageData.data[r + 2] = ct, this.imageData.data[r + 3] = 255;
        }
        e.putImageData(this.imageData, 0, 0);
      }
    };
  }
  _handleHexEditorChange(e) {
    const t = e.composedPath()[0];
    if (t.name === "firstRow") {
      const o = Number(t.value);
      Number.isFinite(o) && o % 16 === 0 && o >= 0 && o <= M && o !== this.hexEditor.values.firstRow && (this.hexEditor = {
        ...this.hexEditor,
        values: {
          ...this.hexEditor.values,
          firstRow: o
        }
      });
    }
  }
  _renderHexView(e) {
    if (!e)
      return;
    const { firstRow: t } = this.hexEditor.values, r = X(0, 8).map((a) => t + a * 16).filter((a) => a <= M).map((a) => At(e, a)), s = `${E(t, 4)} - ${E(
      t + 16 * r.length - 1,
      4
    )}`;
    return n`
      <section>
        <h4>hex view</h4>
        <form @input=${this._handleHexEditorChange} class="hex-form">
          <div class="form-group">
            <input
              id="hex-view-first-row"
              name="firstRow"
              type="number"
              min="0"
              max=${M}
              step="16"
            /><label for="hex-view-first-row">range: ${s}</label>
          </div>
        </form>
        <div class="hex-view">
          <div class="hex-header">${this._hexViewFirstRow}</div>
          ${r.map((a) => n`<div>${a}</div>`)}
        </div>
      </section>
    `;
  }
  firstUpdated() {
    this._animationFrameRequestId = window.requestAnimationFrame(
      this._paintMemoryCanvas
    );
  }
  updated(e) {
    e.has("memoryView") && (this._animationFrameRequestId = window.requestAnimationFrame(
      this._paintMemoryCanvas
    ));
  }
  // Clean up rAF requests that have not been executed yet.
  disconnectedCallback() {
    this._animationFrameRequestId && (window.cancelAnimationFrame(this._animationFrameRequestId), this._animationFrameRequestId = 0);
  }
  render() {
    return n`<article class="bg-primary" part="root-view">
      <section class="memory-map-wrapper">
        <h4>wasm memory (64KiB)</h4>
        <canvas
          width=${b}
          height=${b}
          class="memory-map"
          ${ht(this.memoryCanvasRef)}
        ></canvas>
        <div class="color-formula">${ee}</div>
      </section>
      ${this._renderHexView(this.memoryView)}
    </article>`;
  }
};
w.styles = u(Kt);
T([
  l({ type: String, reflect: !0 })
], w.prototype, "heading", 2);
T([
  l({ type: Object, reflect: !1 })
], w.prototype, "memoryView", 2);
T([
  P()
], w.prototype, "hexEditor", 2);
w = T([
  g(te)
], w);
var oe = Object.defineProperty, se = Object.getOwnPropertyDescriptor, pt = (e, t, o, r) => {
  for (var s = r > 1 ? void 0 : r ? se(t, o) : t, a = e.length - 1, i; a >= 0; a--)
    (i = e[a]) && (s = (r ? i(t, o, s) : i(s)) || s);
  return r && s && oe(t, o, s), s;
};
const re = "wasm4-info-view", ae = [
  { key: "2", description: "Save state" },
  { key: "4", description: "Load state" },
  { key: "R", description: "Reboot cartridge" },
  { key: "F8", description: "Open devtools" },
  { key: "F9", description: "Take screenshot" },
  { key: "F10", description: "Record 4 second video" },
  { key: "F11", description: "Fullscreen" }
], ie = [
  { label: "website", href: "https://wasm4.org/" },
  { label: "docs", href: "https://wasm4.org/docs" },
  { label: "github", href: "https://github.com/aduros/wasm4" }
];
let O = class extends f {
  constructor() {
    super(...arguments), this.heading = "";
  }
  render() {
    return n`
      <article class="bg-primary" part="root-view">
        ${this.heading && n`<h3 class="heading">${this.heading}</h3>`}
        <section>
          <h4>links</h4>
          <ul class="list">
            ${$(
      ie,
      ({ href: e }) => e,
      ({ href: e, label: t }) => n`<li>
                  <a target="_blank" rel="noopener" href=${e}>${t}</a>
                </li>`
    )}
          </ul>
        </section>
        <section>
          <h4>keybindings</h4>
          <table class="table">
            <thead>
              <tr>
                <th>key</th>
                <th>description</th>
              </tr>
            </thead>
            <tbody>
              ${$(
      ae,
      ({ key: e }) => e,
      ({ key: e, description: t }) => n`<tr>
                    <td>${e}</td>
                    <td>${t}</td>
                  </tr>`
    )}
            </tbody>
          </table>
        </section>
        <section>
          <h4>memory map</h4>
          <table class="table">
            <thead>
              <tr>
                <th>address</th>
                <th>size (bytes)</th>
                <th>description</th>
              </tr>
            </thead>
            <tbody>
              ${$(
      Object.entries(dt),
      ([e, { offset: t }]) => t,
      ([e, { offset: t, len: o }]) => n`<tr>
                    <td>0x${E(t)}</td>
                    <td>${o}</td>
                    <td>${e}</td>
                  </tr>`
    )}
            </tbody>
          </table>
        </section>
      </article>
    `;
  }
};
O.styles = u();
pt([
  l({ type: String, reflect: !0 })
], O.prototype, "heading", 2);
O = pt([
  g(re)
], O);
class ne {
  constructor() {
    this.mouseButtons = 0, this.gamepads = [0, 0, 0, 0], this.update = (t) => {
      this.mouseButtons = this.mouseButtons | t.getUint8(B);
      for (let o = 0, r = this.gamepads.length; o < r; o++)
        this.gamepads[o] = t.getUint8(
          wt[`ADDR_GAMEPAD${o + 1}`]
        ) | this.gamepads[o];
    }, this.flush = () => {
      const t = {
        mouseButtons: this.mouseButtons,
        gamepads: this.gamepads.slice()
      };
      return this.mouseButtons = 0, this.gamepads.fill(0), t;
    };
  }
}
class fe {
  constructor() {
    this._enabled = !1, this._bufferedData = new ne(), this._fpsBuffer = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0], this._fpsBufferIdx = 0, this._calcAvgFPS = () => {
      let t = this._fpsBuffer[0];
      for (let o = 1; o < 10; o++)
        t += this._fpsBuffer[o];
      return Math.floor(t / 10);
    }, this._nextFPSBufferIdx = () => (this._fpsBufferIdx == 9 ? this._fpsBufferIdx = 0 : this._fpsBufferIdx++, this._fpsBufferIdx), this.updateCompleted = (t, o) => {
      this._enabled && (this._fpsBuffer[this._nextFPSBufferIdx()] = 1e3 / o, this._bufferedData.update(t.data), this._notifyUpdateCompleted(
        t.data,
        t.wasmBufferByteLen,
        this._calcAvgFPS()
      ));
    }, this.removeDevTools = () => {
      this._enabled && this.toggleDevtools();
    }, this.toggleDevtools = () => {
      this._enabled = !this._enabled, this._enabled ? (window.addEventListener(F, this.removeDevTools), document.body.appendChild(document.createElement(U))) : (window.removeEventListener(F, this.removeDevTools), Array.from(document.body.querySelectorAll(U)).forEach(
        (t) => {
          var o;
          (o = t == null ? void 0 : t.parentElement) == null || o.removeChild(t);
        }
      ));
    }, this._notifyUpdateCompleted = ft(
      (t, o, r) => {
        window.dispatchEvent(
          Et({
            dataView: t,
            wasmBufferByteLen: o,
            fps: r,
            bufferedData: this._bufferedData.flush()
          })
        );
      },
      200
    );
  }
}
export {
  fe as DevtoolsManager,
  p as Wasm4ControlsView,
  v as Wasm4Devtools,
  d as Wasm4Gamepad,
  O as Wasm4InfoView,
  w as Wasm4MemoryView,
  c as Wasm4MouseButtons,
  D as Wasm4Palette,
  F as closeDevtoolsEventType,
  Ct as createCloseDevtoolsEvent,
  Et as createUpdateCompletedEvent,
  z as updateCompletedEventType,
  Yt as wasm4ControlsViewTagName,
  U as wasm4DevtoolsTagName,
  Nt as wasm4GamepadTagName,
  re as wasm4InfoTagName,
  te as wasm4MemoryViewTagName,
  Zt as wasm4MouseTagName,
  Lt as wasm4PaletteTagName
};
